(function () {
    let snapshot = {
        variantId: null,
        quantita: 1,
        testo: '',
        font: '',
        colore: ''
    };

    // Array per salvare le quantità di TUTTI i prodotti identici già nel carrello
    let quantitaPreesistenti = [];

    function aggiornaStatoModale() {
        const modal = document.querySelector(".csh-product-customizer-modal");
        if (!modal) return;

        const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        const inputQty = modal.querySelector(".js-quantity-field-pdp");
        snapshot.variantId = idInput ? idInput.value : null;
        snapshot.quantita = parseInt(inputQty?.value || "1", 10);

        const textareaTesto = modal.querySelector('textarea[name="properties[Testo personalizzato]"]');
        snapshot.testo = textareaTesto ? textareaTesto.value.trim() : '';

        const radioFont = modal.querySelector('input[name="properties[Font]"]:checked');
        snapshot.font = radioFont ? radioFont.value.trim() : '';

        const radioColore = modal.querySelector('input[name="properties[Colore]"]:checked');
        snapshot.colore = radioColore ? radioColore.value.trim() : '';
    }

    document.body.addEventListener('click', (e) => {
        if (e.target.closest('.csh-product-customizer-modal')) {
            setTimeout(aggiornaStatoModale, 50);
        }
    });
    document.body.addEventListener('input', (e) => {
        if (e.target.closest('.csh-product-customizer-modal')) {
            aggiornaStatoModale();
        }
    });

    // Mappa TUTTI gli articoli identici già presenti salvando un array delle loro quantità attuali
    function memorizzaQuantitaEsistenti() {
        quantitaPreesistenti = [];
        const containerUpCart = document.querySelector('#upCart');
        if (!containerUpCart || !containerUpCart.shadowRoot) return;

        const cartItems = containerUpCart.shadowRoot.querySelectorAll('.upcart-public-cart-item');
        for (const item of cartItems) {
            if (verificaMatchProprieta(item, snapshot)) {
                const qtyInput = item.querySelector('.upcart-public-component-product-tile__quantity-selector input');
                if (qtyInput) {
                    quantitaPreesistenti.push(parseInt(qtyInput.value || "1", 10));
                }
            }
        }
    }

    // Funzione atomica di confronto proprietà dello snapshot
    function verificaMatchProprieta(item, snapshotCongelato) {
        const link = item.querySelector('a[href*="variant="]');
        if (snapshotCongelato.variantId && link && !link.getAttribute('href').includes(snapshotCongelato.variantId)) return false;

        const propsContainer = item.querySelector('.upcart-public-component-product-tile__properties');
        if (!propsContainer) return false;

        const propsText = propsContainer.textContent.toLowerCase();
        const matchTesto = !snapshotCongelato.testo || propsText.includes(snapshotCongelato.testo.toLowerCase());
        const matchFont = !snapshotCongelato.font || propsText.includes(snapshotCongelato.font.toLowerCase());
        const matchColore = !snapshotCongelato.colore || propsText.includes(snapshotCongelato.colore.toLowerCase());

        return (matchTesto && matchFont && matchColore);
    }

    // Identifica il nuovo elemento escludendo per associazione 1:1 le vecchie quantità salvate
    function cercaNuovoElementoNelShadowDOM(shadowRoot, snapshotCongelato) {
        if (!shadowRoot) return null;
        
        const cartItems = shadowRoot.querySelectorAll('.upcart-public-cart-item');
        
        // Cloniamo l'array delle vecchie quantità per poterlo consumare durante i match temporanei
        let poolVecchieQuantita = [...quantitaPreesistenti];
        
        for (const item of cartItems) {
            if (verificaMatchProprieta(item, snapshotCongelato)) {
                const qtyInput = item.querySelector('.upcart-public-component-product-tile__quantity-selector input');
                const valoreAttuale = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;

                // Controlliamo se questa quantità fa parte del blocco vecchio
                const indexInPool = poolVecchieQuantita.indexOf(valoreAttuale);
                
                if (indexInPool !== -1) {
                    // Trovato match con un vecchio elemento: lo consumiamo dal pool e saltiamo questo nodo
                    poolVecchieQuantita.splice(indexInPool, 1);
                    continue;
                }
                
                // Se non è nel pool delle vecchie quantità, è matematicamente l'ultimo elemento inserito
                return item;
            }
        }
        return null;
    }

    function impostaQuantitaInput(targetItemEl, targetQty) {
        const qtyInput = targetItemEl.querySelector('.upcart-public-component-product-tile__quantity-selector input');
        if (!qtyInput) return;

        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
        nativeInputValueSetter.call(qtyInput, targetQty);

        const inputEvent = new Event('input', { bubbles: true });
        qtyInput.dispatchEvent(inputEvent);

        const enterKeyDownEvent = new KeyboardEvent('keydown', {
            key: 'Enter', code: 'Enter', keyCode: 13, which: 13, bubbles: true, cancelable: true
        });
        qtyInput.dispatchEvent(enterKeyDownEvent);

        const enterKeyUpEvent = new KeyboardEvent('keyup', {
            key: 'Enter', code: 'Enter', keyCode: 13, which: 13, bubbles: true, cancelable: true
        });
        qtyInput.dispatchEvent(enterKeyUpEvent);

        qtyInput.blur();
    }

    function osservaEAllineaQuantita(targetQty, snapshotCongelato) {
        const containerUpCart = document.querySelector('#upCart');
        
        function monitoraShadowRoot(shadowRoot) {
            const itemImmediato = cercaNuovoElementoNelShadowDOM(shadowRoot, snapshotCongelato);
            if (itemImmediato) {
                impostaQuantitaInput(itemImmediato, targetQty);
                return;
            }

            const shadowObserver = new MutationObserver((mutations, obs) => {
                const targetItemEl = cercaNuovoElementoNelShadowDOM(shadowRoot, snapshotCongelato);
                if (targetItemEl) {
                    impostaQuantitaInput(targetItemEl, targetQty);
                    obs.disconnect();
                }
            });

            shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
            setTimeout(() => shadowObserver.disconnect(), 4000);
        }

        if (containerUpCart && containerUpCart.shadowRoot) {
            monitoraShadowRoot(containerUpCart.shadowRoot);
        } else {
            const bodyObserver = new MutationObserver((mutations, obs) => {
                const el = document.querySelector('#upCart');
                if (el && el.shadowRoot) {
                    monitoraShadowRoot(el.shadowRoot);
                    obs.disconnect();
                }
            });
            bodyObserver.observe(document.body, { childList: true, subtree: true });
            setTimeout(() => bodyObserver.disconnect(), 4000);
        }
    }

    // --- INTERCETTAZIONE FETCH ---
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
        
        if (url.includes('/cart/add.js') || url.includes('/cart/add')) {
            aggiornaStatoModale();
            const targetQty = snapshot.quantita;
            const snapshotCongelato = { ...snapshot };
            
            if (targetQty > 1) {
                memorizzaQuantitaEsistenti();
            }

            const response = await originalFetch.apply(this, args);

            if (response.ok && targetQty > 1) {
                osservaEAllineaQuantita(targetQty, snapshotCongelato);
            }
            return response;
        }
        return originalFetch.apply(this, args);
    };

    // --- INTERCETTAZIONE XHR ---
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
        this._url = typeof url === 'string' ? url : url?.toString() || '';
        return originalXHROpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function() {
        if (this._url && (this._url.includes('/cart/add.js') || this._url.includes('/cart/add'))) {
            aggiornaStatoModale();
            const targetQty = snapshot.quantita;
            const snapshotCongelato = { ...snapshot };
            
            if (targetQty > 1) {
                memorizzaQuantitaEsistenti();
            }

            this.addEventListener('load', function() {
                if (this.status >= 200 && this.status < 300 && targetQty > 1) {
                    osservaEAllineaQuantita(targetQty, snapshotCongelato);
                }
            });
        }
        return originalXHRSend.apply(this, arguments);
    };
})();